import InitialData from "./appData/initialData"
import { isBanner, isPromo } from "./utils/utils"

function createStyleConfig(data: InitialData) {
  if (isBanner()) {
    return createBannerStyleConfig(data)
  }

  let backgroundColor = data.darkMode ? "#1d212b" : "#f1f4f8"
  const promo = isPromo()
  if (promo) {
    backgroundColor = "#1d212b"
  }

  return {
    statusBarStyle: "visible",
    hideInsets: true,
    hideBackButton: true,
    hideNavigationBar: true,
    backgroundColor,
    isPromo: promo,
  }
}

function createBannerStyleConfig(initialData: InitialData) {
  const isAlbumList = initialData?.source == "albumListTop"

  return {
    height: 210,
    margin: isAlbumList ? 0 : 16,
    isPromo: true,
  }
}

export default createStyleConfig
